import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IConfigDataRetention,
  ISearchConfigDataRetention,
} from '../../../services/master/dataRetention/dataRetention.model';
import dataRetentionService from '../../../services/master/dataRetention/dataRetention.service';

export const searchConfigDataRetention = createAsyncThunk(
  'searchConfigDataRetention',
  async (searchParam?: ISearchConfigDataRetention) => {
    const response = await dataRetentionService
      .searchConfigDataRetention(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getConfigDataRetentionById = createAsyncThunk(
  'getConfigDataRetentionById',
  async (id: number) => {
    const response = await dataRetentionService.getConfigDataRetentionById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const updateConfigDataRetention = createAsyncThunk(
  'updateConfigDataRetention',
  async (data: IConfigDataRetention) => {
    const response = await dataRetentionService.updateConfigDataRetention(data).then((res) => {
      return res.body;
    });
    return response;
  }
);
